import { render, staticRenderFns } from "./VincularProdutoListModal.vue?vue&type=template&id=aeaf708c&scoped=true"
import script from "./VincularProdutoListModal.vue?vue&type=script&lang=js"
export * from "./VincularProdutoListModal.vue?vue&type=script&lang=js"
import style0 from "./VincularProdutoListModal.vue?vue&type=style&index=0&id=aeaf708c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaf708c",
  null
  
)

export default component.exports